export const accountComponents = {
  // OtaLinksBar.vue — OTA links bar
  otaLinks: {
    copied: "Copiato!",
    copy: "Copia",
    edit: "Modifica",
    remove: "Rimuovi",
    addLink: "Link OTA",
    modalEyebrow: "Link dell'annuncio sull'OTA",
    modalEyebrowUnit: "Link di questa unità sull'OTA",
    editTitle: "Modifica link",
    addTitle: "Aggiungi link OTA",
    modalHint: "Incolla l'URL pubblico di <b>questo annuncio</b> sull'OTA. Ti permette di copiarlo e aprirlo rapidamente.",
    urlLabel: "URL dell'annuncio",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva link",
    saveError: "Impossibile salvare il link. Controlla l'URL.",
    fromListing: "dall'annuncio",
    inheritedNote: "È il link dell'annuncio. Finché questa unità non ha il suo, è quello che inviamo.",
    override: "Imposta il suo",
    modalHintUnit: "Incolla l'URL pubblico di <b>questa unità</b> sull'OTA. Se lo imposti, inviamo questo; se lo lasci vuoto, inviamo quello dell'annuncio.",
  },

  // GuestJourneySimulator.vue — guest journey simulator
  journeySim: {
    title: "Simula il percorso dell'ospite",
    badge: "Test",
    intro: "Ripercorri tutto il processo —dalla prenotazione alla recensione— in una chat WhatsApp. Inserisci un nome e un numero e premi <strong>play</strong>. Se attivi «Invia al cellulare», ogni messaggio viene realmente inviato al numero, così puoi provarlo e chattare con l'AI Agent.",
    guestNameLabel: "Nome dell'ospite",
    guestNamePlaceholder: "es. Laura García",
    phoneLabel: "Numero WhatsApp (per il test)",
    phoneHint: "Formato internazionale, es. +34 600123456",
    toggleTitle: "Invia anche al cellulare",
    toggleDesc: "Ogni passaggio viene realmente inviato al numero indicato sopra",
    warn: "Invia prima «ciao» al numero dal tuo telefono per aprire la finestra di 24 ore di WhatsApp; così riceverai i messaggi all'istante.",
    reset: "Ricomincia",
    prev: "Precedente",
    pause: "Pausa",
    play: "Play",
    continue: "Continua",
    next: "Avanti",
    stepProgress: "Passaggio {current} di {total}",
    guestFallback: "Ospite",
    propertyFallback: "il tuo alloggio",
    testNumberFallback: "numero di test",
    dayLabel: "Percorso dell'ospite",
    loadingMsgs: "Caricamento dei tuoi messaggi…",
    pressPlay: "Premi <strong>Play</strong> per iniziare il percorso ▶",
    hintSending: "Invio in tempo reale attivo · ogni passaggio arriva a {phone}",
    hintSimulated: "Vista simulata · attiva «Invia al cellulare» per testare su un telefono reale",
    toastInvalidPhone: "Inserisci un numero WhatsApp valido per inviare al cellulare.",
    toastSendFailed: "Invio non riuscito.",
    toastSendMobileFailed: "Invio al cellulare non riuscito.",
    // Simulated WhatsApp messages ({{...}} are resolved by resolve())
    msgConfirmation: "Ciao *{{nombre_huesped}}* 👋\n\nLa tua prenotazione presso *{{nombre_alojamiento}}* è confermata ✅\n\nCodice prenotazione: *6233Q1VC5*\nDate: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nTramite questo WhatsApp puoi richiedere il link per il check-in online e ricevere le istruzioni per l'arrivo.",
    msgCheckinPrompt: "*Ciao* 👋 Sono l'assistente virtuale di *{{nombre_alojamiento}}*.\n\nPremi *Ok* per continuare con il check-in.",
    msgChooseLanguage: "Scegli la tua lingua · Choose your language",
    msgCheckinLink: "*Grazie* 👋 Ecco il link per effettuare il check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 Benvenuto presso *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nGrazie per aver completato la registrazione. Ecco tutte le informazioni sul tuo soggiorno.",
    msgAccess: "🔒🔑 *Codice di accesso · {{nombre_alojamiento}}*\n\nIl tuo codice è: *58117*\n\nValido per tutta la durata del soggiorno.",
    msgArrival: "🏡 *Istruzioni per l'arrivo*\n\nAll'arrivo, dirigiti verso l'ingresso principale e inserisci il tuo codice sulla serratura. 🔑\n\nBuon soggiorno! ✨",
    msgGuestCheckout: "Ciao, a che ora è il check-out?",
    msgCheckoutReply: "Ciao! Il check-out è entro le *12:00* 🕚 Se hai bisogno di partire più tardi, posso verificare la possibilità di un late check-out per te 😊",
    msgCheckout: "Ciao *{{nombre_huesped}}* 👋\n\nTi ricordiamo che *il tuo soggiorno termina domani* presso *{{nombre_alojamiento}}*.\n\n🕚 L'orario massimo per il check-out è le *{{hora_salida}}*.\n\nGrazie mille per la tua visita e buon viaggio! 😊",
    msgReview: "⭐ Com'è stato il tuo soggiorno presso *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nCi farebbe piacere conoscere la tua opinione. Lasciaci la tua recensione qui 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — guest journey timeline
  journeyTimeline: {
    title: "Percorso dell'ospite",
    subtitle: "Dalla prenotazione alla partenza. Passa il mouse su ogni evento per vedere il messaggio.",
    disabled: "Disattivato",
    clickToConfigure: "Clicca per configurare",
    nameFallback: "il tuo alloggio",
    // Node labels
    labelLead: "Prenotazione / Lead",
    labelConfirm: "Conferma",
    labelCheckinLink: "Link per il check-in",
    labelWelcome: "Benvenuto",
    labelAccess: "Accesso / Serratura",
    labelArrival: "Istruzioni per l'arrivo",
    labelCheckout: "Messaggio di partenza",
    labelReview: "Recensione",
    // Timing of each node
    whenLead: "Alla prenotazione o al primo messaggio",
    whenConfirm: "Prenotazione confermata",
    whenCheckinLink: "Prima dell'arrivo",
    whenWelcome: "Dopo la registrazione",
    whenAccess: "Giorno dell'arrivo",
    whenArrival: "Giorno dell'arrivo",
    whenCheckout: "Vigilia del check-out",
    whenReview: "Dopo il check-out",
    // WhatsApp previews
    previewLead: "👋 Ciao! Sono l'assistente virtuale di *{name}*.\n\nSono qui per aiutarti con la tua prenotazione e rispondere a qualsiasi domanda.",
    previewConfirm: "Ciao *Laura García* 👋\n\nLa tua prenotazione presso *{name}* è confermata ✅\n\nCodice prenotazione: *6233Q1VC5*\nDate: *05/06/2026* – *07/06/2026* 📅\n\nTramite questo WhatsApp puoi richiedere il link per il check-in online e ricevere anche le istruzioni per l'arrivo.\nSe hai bisogno di aiuto prima o durante il soggiorno, scrivici qui 💬",
    previewWelcome: "👋 Benvenuto presso *{name}*!\n\nGrazie per aver completato la registrazione. Ecco tutte le informazioni sul tuo soggiorno.",
    previewAccess: "🔒🔑 *Codice di accesso · {name}*\n\nIl tuo codice è: *58117*\n\nValido per tutta la durata del soggiorno.",
    previewArrival: "🏡 *Istruzioni per l'arrivo*\n\nAll'arrivo, dirigiti verso l'ingresso principale dell'alloggio. 🔑\n\nBuon soggiorno! ✨",
    previewCheckout: "Ciao 👋\n\nTi ricordiamo che *il tuo soggiorno termina domani* presso *{name}*.\n\n🕚 L'orario massimo per il check-out è le *12:00*.\n\nBuon viaggio! 😊",
    previewReview: "⭐ Com'è stato il tuo soggiorno presso *{name}*?\n\nCi farebbe piacere conoscere la tua opinione. Lasciaci la tua recensione qui 👉 …",
    previewLeadNoWaba: "📲 *Attiva il tuo AI Agent* per gestire le nuove prenotazioni su WhatsApp collegando il tuo numero.\n\nIn questo modo l'assistente risponderà anche a chi non è ancora cliente, rispondendo alle domande sui tuoi alloggi e accompagnandolo verso la prenotazione.",
    // Full "Check-in link" conversation
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Scegli la tua lingua · Choose your language",
    chatCheckinLink: "*Grazie* 👋 Ecco il link per effettuare il check-in. 😎\n\nhttps://guest.wacheckin.com/…",
    // Access messages (locks)
    lockLabelFallback: "Ingresso",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nIl tuo codice di accesso è: *58117*\n\nValido per tutta la durata del soggiorno.",
    lockNone: "🔑 *{label} · {name}*\n\nLa cassetta portachiavi si apre con il codice: *{code}*\n\nAll'interno troverai le chiavi dell'alloggio.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nIl codice della serratura è: *{code}*\n\nUsalo per aprire la porta.",
    // Departure message (fallback)
    checkoutFallback: "Ciao, *María* 👋\n\nTi ricordiamo che il tuo soggiorno termina domani presso *{name}*.\n\n🕚 L'orario massimo per il check-out è le *{time}*.\n\nGrazie mille per il tuo soggiorno. Buon viaggio! 😊",
  },

  // ListingIcalPanel.vue — iCal sync panel
  icalPanel: {
    eyebrow: "Calendario iCal",
    heading: "Sincronizzazione iCal",
    pageDesc: "Esporta le tue prenotazioni su altre piattaforme e importa calendari esterni per bloccare automaticamente le date sul tuo annuncio.",
    loading: "Caricamento della configurazione…",
    exportLabel: "Il tuo link iCal (esportazione)",
    exportDesc: "Copia questo link e incollalo su Airbnb, Booking.com o qualsiasi piattaforma che supporti la sincronizzazione iCal. Recupereranno automaticamente le tue prenotazioni.",
    copied: "Copiato",
    copy: "Copia",
    tipAllUnits: "Questo link include le prenotazioni di <strong>tutte le unità</strong> dell'annuncio.",
    tipHotelRooms: "Ogni <strong>camera fisica</strong> ha il proprio link. Collegalo su Airbnb/Booking per quella specifica camera e verranno esportate solo le prenotazioni di QUELLA camera.",
    importLabel: "Calendari esterni (importazione)",
    syncing: "Sincronizzazione…",
    syncAll: "Sincronizza tutto",
    importDesc: "Incolla gli URL iCal delle tue altre piattaforme (Airbnb, Booking.com, ecc.) e Wacheckin bloccherà automaticamente quelle date sul tuo calendario.",
    lastSync: "Ultima sincronizzazione: {date}",
    delete: "Elimina",
    empty: "Non hai ancora collegato alcun calendario esterno.",
    addExternal: "Aggiungi calendario esterno",
    newExternal: "Nuovo calendario esterno",
    nameLabel: "Nome del calendario",
    namePlaceholder: "es. Airbnb - Apt 1",
    physicalRoom: "Camera fisica",
    listingUnit: "Unità dell'annuncio",
    selectRoomPlaceholder: "Seleziona una camera…",
    selectUnitPlaceholder: "Seleziona un'unità…",
    urlLabel: "URL del calendario iCal",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveSync: "Salva e sincronizza",
    defaultGroup: "Camere",
    toastLoadError: "Impossibile caricare la configurazione iCal.",
    toastSelectUnit: "Seleziona una camera / unità.",
    toastAdded: "Calendario aggiunto e sincronizzato con successo.",
    toastAddError: "Errore durante l'aggiunta del calendario.",
    deleteConfirm: 'Eliminare "{name}" e tutte le sue prenotazioni bloccate?',
    toastDeleted: "Calendario eliminato.",
    toastDeleteError: "Impossibile eliminare il calendario.",
    toastSyncError: "Errore durante la sincronizzazione.",
  },

  // ListingIcalModal.vue — iCal sync modal
  icalModal: {
    title: "Sincronizzazione iCal",
    loading: "Caricamento della configurazione…",
    exportLabel: "Il tuo link iCal (esportazione)",
    exportDesc: "Copia questo link e incollalo su Airbnb, Booking.com o qualsiasi piattaforma che supporti la sincronizzazione iCal. Recupereranno automaticamente le tue prenotazioni.",
    copied: "Copiato",
    copy: "Copia",
    tipAllUnits: "Questo link include le prenotazioni di <strong>tutte le unità</strong> dell'annuncio.",
    tipHotelRooms: "Ogni <strong>camera fisica</strong> ha il proprio link. Collegalo su Airbnb/Booking per quella specifica camera e verranno esportate solo le prenotazioni di QUELLA camera.",
    importLabel: "Calendari esterni (importazione)",
    syncing: "Sincronizzazione…",
    syncAll: "Sincronizza tutto",
    importDesc: "Incolla gli URL iCal delle tue altre piattaforme (Airbnb, Booking.com, ecc.) e Wacheckin bloccherà automaticamente quelle date sul tuo calendario.",
    lastSync: "Ultima sincronizzazione: {date}",
    delete: "Elimina",
    empty: "Non hai ancora collegato alcun calendario esterno.",
    addExternal: "Aggiungi calendario esterno",
    newExternal: "Nuovo calendario esterno",
    nameLabel: "Nome del calendario",
    namePlaceholder: "es. Airbnb - Apt 1",
    physicalRoom: "Camera fisica",
    listingUnit: "Unità dell'annuncio",
    selectRoomPlaceholder: "Seleziona una camera…",
    selectUnitPlaceholder: "Seleziona un'unità…",
    urlLabel: "URL del calendario iCal",
    cancel: "Annulla",
    saveSync: "Salva e sincronizza",
    defaultGroup: "Camere",
    toastLoadError: "Impossibile caricare la configurazione iCal.",
    toastSelectUnit: "Seleziona una camera / unità.",
    toastAdded: "Calendario aggiunto e sincronizzato con successo.",
    toastAddError: "Errore durante l'aggiunta del calendario.",
    deleteConfirm: 'Eliminare "{name}" e tutte le sue prenotazioni bloccate?',
    toastDeleted: "Calendario eliminato.",
    toastDeleteError: "Impossibile eliminare il calendario.",
    toastSyncError: "Errore durante la sincronizzazione.",
  },
};
